import * as React from "react"
import Switch from "@material-ui/core/Switch"
import { Button } from 'reactstrap'
import { renderLoadedText } from "src/share/utils/placeholders"

export const loadingRow = (width: number) => <p className="row-skeleton">{renderLoadedText('', false, 1, width)}</p>

export const tableLoading = (selector: string, isLoading: boolean, width: number) =>
  isLoading ?
    { cell: () => loadingRow(width) } :
    { selector }

export const tableLoadingSwitch = (selector: string, isLoading: boolean) =>
  isLoading ?
    { cell: () => <Switch color="primary" checked={false} disabled={true} /> } :
    { selector }

export const tableLoadingButton = (selector: string, isLoading: boolean, buttonLabel: string) =>
  isLoading ?
    {
      cell: () =>
        <Button
          className="btn btn-blue float-right"
          disabled={true}
        >
          {buttonLabel}
        </Button>
    } :
    { selector }